import { get } from '@ebay/presence-ui/lib/object-helpers';
import storeEvent from '../../utils/store-event';

export default class {
    onCreate(input) {
        const catMod = get(input, 'page.modules.STORE_CATEGORIES_MODULE', {});
        this.leftNavBtnTrackOpen = JSON.stringify(get(catMod, 'toggleAction.action.trackingList.0', {}));
        this.leftNavBtnTrackClose = JSON.stringify(get(catMod, 'toggleAction.action.trackingList.1', {}));
        this.state = {
            leftNavBtnAriaExpanded: 'false',
            leftNavBtnTracking: this.leftNavBtnTrackOpen,
            leftNavBtnAriaLabel: get(catMod, 'label', ''),
            hasCategories: !!get(catMod, 'categories', false)
        };
    }
    onMount() {
        storeEvent.toggleLeftNavDone.listen(data => {
            this.state.leftNavBtnAriaExpanded = `${data.isOpen}`; // Needs to be string
            this.state.leftNavBtnTracking = data.isOpen ? this.leftNavBtnTrackClose : this.leftNavBtnTrackOpen;
        });
    }
    toggleLeftNav() {
        storeEvent.toggleLeftNav.dispatch();
    }
}
